import React from "react";
import { Box, Typography } from "@mui/material";
import { useAppSelector } from "../../../store/hooks.ts";
import { selectSelectedItem } from "../../../store/slices/searchSlice.ts";
import PatientView from "../../patient/PatientView.tsx";

const SelectedResult = () => {
	const selectedItem = useAppSelector(selectSelectedItem);

	if (!selectedItem) return null;

	const renderDetails = () => {
		switch (selectedItem.type) {
			case "patient":
				return <PatientView />;
			default:
				return (
					<Typography variant="body2">
						Unknown result type.
					</Typography>
				);
		}
	};

	return <Box>{renderDetails()}</Box>;
};

export default SelectedResult;
